import { Container } from "components";
import React, { useEffect, useState } from "react";
import api from "services/api";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Pagination from "components/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";

export const CorperatorsList = () => {
  const navigate = useNavigate();
  const [corperators, setCorperators] = useState([]);
  const [showCorperators , setShowCorperators ] = useState(false);
  const [currentPage , SetCurrentPage ] = useState(1);
  const [search , setSearch ] = useState("");
  const [meta, setMeta] = useState({});

  const fetchCorperate = async (page=1,query="") => {
    try {
      const response = await api.get(`/corporate-entities`);
      setCorperators(response?.data?.data);
       
      SetCurrentPage(page)
      console.log("fetchCorperate:", response.data?.data);
    } catch (error) {
      console.log(" fetchCorperate Error:", error);
    }
  };
  const handleSearch = () => {
    const query = search.trim(); // Trim whitespace from the input
  fetchCorperate(1, query); // Pass an empty string if the input is empty
  };

  useEffect(() => {
    fetchCorperate();
  }, []);
  return (
    <Container>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y" style={{height:"43px"}}>
          {/* <ul className="nav nav-pills flex-column flex-md-row mb-4">
            <li className="nav-item">
              <h4 className={`py-3 mb-4`}>
                {!showCorperators ? "Corporates " : "Corporates details"}
              </h4>
            </li>
          </ul> */}
          <h4 className="card-header">Corporates</h4>
          <div className="d-flex justify-content-end">
            <input 
              type="text"
              // value={search}
              // onChange={(e) => setSearch(e.target.value)} // Update the search state.
              // onKeyDown={(e) => {
              //   if (e.key === 'Enter') handleSearch(); // Trigger search on Enter
              // }}
              placeholder="search"
              className=" me-3 mb-4 "
              style={{ outline: 'none', boxShadow: 'none', border: "1px solid transparent"}}
            />
            <button  className="btn btn-primary me-2 mb-4" 
            // onClick={handleSearch}
            >
              Search
            </button>
            <button className="btn btn-primary me-5 mb-4" 
            // onClick={() => navigate("/addCorporates")}
            >
              Add Corporates
            </button>
          </div>
          <div class="card-datatable table-responsive">
            <table class="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
              <thead>
                <tr>
                  <th>Sno</th>
                  <th>Name</th>
                  <th>email</th>

                  <th class="text-truncate">Industry</th>
                  <th class="text-truncate">Phone No</th>
                  {/* <th class="cell-fit">Phone No</th>*/}
                  <th>Action</th> 
                </tr>
              </thead>
              <tbody>
                    {corperators?.data?.map( (res , index) => {
                      const serialNumber = (currentPage - 1) * corperators?.meta?.per_page + (index + 1);
                      return (
                        <tr>
                          <td>{serialNumber}</td>
                          <td>{res?.name}</td>
                          <td>{res?.contact_email}</td>
                          <td>{res?.industry?.name}</td>
                          <td>{res?.contact_phone}</td>
                          <td>
                            <FontAwesomeIcon
                              icon={faEye}
                              onClick={() => navigate(`/corperatesDetails/${res?.corporate_id}`)}
                              className="me-3"
                            />
                          </td>
                        </tr>
                      )
                    })}
              </tbody>
            </table>
            {/* {corperators?.meta?.total > 0 && (
              <Pagination 
                totalPages={corperators?.meta?.total}
                  perPage={corperators?.meta?.per_page}
                  handleFunction={fetchCorperate}

              
        
              />
            )} */}
          </div>
        </div>
        {/* <Footer /> */}
        <div class="content-backdrop fade"></div>
      </div>
    </Container>
  );
};
